import { motion } from "framer-motion";
import { CERTIFICATIONS } from "@/lib/site-data";
import { BadgeCheck } from "lucide-react";

export default function Quality() {
  return (
    <section data-testid="quality-section" id="quality" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Quality & Compliance</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            Audited, accredited, <span className="gold-gradient-text font-medium">accountable</span>.
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {CERTIFICATIONS.map((c, i) => (
            <motion.div
              key={c.code}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`cert-${i}`}
              className="aspect-square flex flex-col items-center justify-center text-center p-3 border border-[#E5E5E5] rounded-lg bg-[#F4F9FC] hover:bg-white hover:border-[#D4AF37] hover:shadow-[0_16px_40px_rgba(212,175,55,0.15)] transition-all"
            >
              <BadgeCheck className="w-6 h-6 text-[#D4AF37] mb-2" strokeWidth={1.5} />
              <div className="font-heading font-medium text-[#0A0A0A] text-lg">{c.code}</div>
              <div className="text-[10px] uppercase tracking-[0.14em] text-[#4B5563] mt-1 leading-tight">{c.note}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
